import { render, staticRenderFns } from "./AgencyNeedCard.vue?vue&type=template&id=656a0f91&scoped=true"
import script from "./AgencyNeedCard.vue?vue&type=script&lang=js"
export * from "./AgencyNeedCard.vue?vue&type=script&lang=js"
import style0 from "./AgencyNeedCard.vue?vue&type=style&index=0&id=656a0f91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a0f91",
  null
  
)

export default component.exports